import React, { useState } from "react";
import { PeekBox, PeekCheckbox, PeekFormControlLabel, PeekStack, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export const CommunityFeaturesSelector = ({ form, field }) => {
    const intl = useIntl();
    const theme = useTheme();
    const [checkedStatus, setCheckedStatus] = useState(field.value || []);
    const FEATURES = [
        {
            value: "Prospect Intelligence" /* PolicyActions.PROSPECT_INTELLIGENCE */,
            label: intl.formatMessage(messages.prospectIntelligenceFeature),
        },
        {
            value: "Analytics" /* PolicyActions.ANALYTICS */,
            label: intl.formatMessage(messages.analyticsFeature),
        },
        {
            value: "SGT" /* PolicyActions.SGT */,
            label: intl.formatMessage(messages.SGTFeature),
        },
        {
            value: "Magic Button" /* PolicyActions.MAGIC_BUTTON */,
            label: intl.formatMessage(messages.MagicButtonFeature),
        },
        {
            value: "AutoScan" /* PolicyActions.AUTOSCAN */,
            label: intl.formatMessage(messages.AutoscanFeature),
        },
        {
            value: "Self_Scanning" /* PolicyActions.SELF_SCAN */,
            label: intl.formatMessage(messages.SelfScanFeature),
        },
        {
            value: "Widget_CASA" /* PolicyActions.WIDGET_CASA */,
            label: intl.formatMessage(messages.WidgetCasaFeature),
        },
        {
            value: "VT_CASA" /* PolicyActions.VT_CASA */,
            label: intl.formatMessage(messages.VTCasaFeature),
        },
        {
            value: "SGT_CASA" /* PolicyActions.SGT_CASA */,
            label: intl.formatMessage(messages.SGTCasaFeature),
        },
    ];
    const handleSelectFilter = (statusChecked) => {
        const newFilters = (checkedStatus === null || checkedStatus === void 0 ? void 0 : checkedStatus.includes(statusChecked))
            ? checkedStatus === null || checkedStatus === void 0 ? void 0 : checkedStatus.filter((status) => status !== statusChecked)
            : [...(checkedStatus !== null && checkedStatus !== void 0 ? checkedStatus : []), statusChecked];
        setCheckedStatus(newFilters);
        // @ts-ignore
        form.setFieldValue(field.name, newFilters);
    };
    const FeatureCheckbox = ({ value, label }) => (React.createElement(PeekFormControlLabel, { key: value, label: label, control: React.createElement(PeekCheckbox, { color: "secondary", sx: { p: theme.spacing(0.3) }, checked: checkedStatus.includes(value), onChange: () => handleSelectFilter(value) }) }));
    return (React.createElement(PeekBox, { my: 1 },
        React.createElement(PeekTypography, { variant: "h4" }, intl.formatMessage(messages.communityFeatures)),
        " ",
        React.createElement(PeekStack, { direction: "row", gap: theme.spacing(3), ml: theme.spacing(0.5), mt: theme.spacing(0.7) }, Array.from({ length: 3 }, (_, columnIndex) => (React.createElement(PeekStack, { direction: "column", key: columnIndex }, FEATURES.filter((_, index) => index % 3 === columnIndex).map((feature) => (React.createElement(FeatureCheckbox, Object.assign({ key: feature.value }, feature))))))))));
};
export default CommunityFeaturesSelector;
